'use strict'

const SELECTORS = {
    element: '.js-cart',
    product: '.js-cart-product',
    qtyWrp: '.js-qty-wrp',
    qtyBtnMinus: '.js-cart-qty-minus',
    qtyBtnPlus: '.js-cart-qty-plus',
    qtyInput: '.js-cart-qty-input'
};

$(() => {
    $(SELECTORS.product).each(function () {
        const $product = $(this);
        const $qtyInput = $product.find(SELECTORS.qtyInput);
        const dataMin = parseInt($qtyInput.attr('min'), 10);
        const dataMax = parseInt($qtyInput.attr('max'), 10);
        let dataValue = parseInt($qtyInput.val(), 10);

        if (dataValue <= dataMin) {
            $product.find(SELECTORS.qtyWrp).addClass('js-cart-qty-only-one');
        }
        if (dataValue >= dataMax) {
            $product.find(SELECTORS.qtyBtnPlus).addClass('cc-disabled').attr('disabled', true);
        }

        if ($product.find('.cc-cart__errorToast').not('.d-none').length > 0) {
            $product.find(SELECTORS.qtyBtnPlus).attr('disabled', 'disabled').addClass('cc-cart__qtyButton--disabled');
        }
    });

    // Quantity Decrease Button Click Management
    $(document).on('click', SELECTORS.qtyBtnMinus, function () {
        if ($(this).closest(SELECTORS.qtyWrp).hasClass('js-cart-qty-only-one')) {
            return;
        }

        const $btn = $(this);
        const $product = $btn.closest(SELECTORS.product);
        const $qtyInput = $product.find(SELECTORS.qtyInput);
        const dataMin = parseInt($qtyInput.attr('min'), 10);
        const dataMax = parseInt($qtyInput.attr('max'), 10);
        let dataValue = parseInt($qtyInput.val(), 10);

        if (dataValue > dataMin) {
            dataValue -= 1;
            $qtyInput.val(dataValue).trigger('change');
        }

        if (dataValue <= dataMin) {
            $product.find(SELECTORS.qtyWrp).addClass('js-cart-qty-only-one');
        }

        if (dataValue < dataMax) {
            $product.find(SELECTORS.qtyBtnPlus).removeClass('cc-disabled').attr('disabled', false);
        }
    });

    // Quantity Increase Button Click Management
    $(document).on('click', SELECTORS.qtyBtnPlus, function () {
        const $btn = $(this);
        const $product = $btn.closest(SELECTORS.product);

        // Prevent action if product has invalid pricebook or is not orderable
        if ($product.find('.cc-cart__errorToast').not('.d-none').length > 0) {
            return;
        }

        const $qtyInput = $product.find(SELECTORS.qtyInput);
        const dataMin = parseInt($qtyInput.attr('min'), 10);
        const dataMax = parseInt($qtyInput.attr('max'), 10);
        let dataValue = parseInt($qtyInput.val(), 10);

        if (dataValue < dataMax) {
            dataValue += 1;
            $qtyInput.val(dataValue).trigger('change');
        }

        if (dataValue >= dataMax) {
            $btn.addClass('cc-disabled').attr('disabled', true);
        }

        if (dataValue > dataMin) {
            $product.find(SELECTORS.qtyWrp).removeClass('js-cart-qty-only-one');
        }
    });

    function refreshCardQtyState($product) {
        const $qtyInput = $product.find(SELECTORS.qtyInput);
        const $qtyWrp = $product.find(SELECTORS.qtyWrp);
        const min = parseInt($qtyInput.attr('min'), 10);
        const max = parseInt($qtyInput.attr('max'), 10);
        const val = parseInt($qtyInput.val(), 10);
        const hasError = $product.find('.cc-cart__errorToast').not('.d-none').length > 0;

        $qtyWrp.toggleClass('js-cart-qty-only-one', val <= min);

        if (hasError || val >= max) {
            $product.find(SELECTORS.qtyBtnPlus)
                .addClass('cc-disabled cc-cart__qtyButton--disabled')
                .attr('disabled', true);
        } else {
            $product.find(SELECTORS.qtyBtnPlus)
                .removeClass('cc-disabled cc-cart__qtyButton--disabled')
                .attr('disabled', false);
        }
    }

    // After any cart AJAX update, sync error toast visibility and qty buttons from server response
    $('body').on('cart:update', function (e, data) {
        const items = (data && data.items) || (data && data.basket && data.basket.items);
        if (!items) return;

        items.forEach(function (item) {
            const $product = $('.uuid-' + item.UUID);
            if (!$product.length) return;

            const hasError = item.isPricebookValid === false || !item.isOrderable;
            $product.find('.cc-cart__errorToast').toggleClass('d-none', !hasError);

            if (item.quantityOptions && item.quantityOptions.maxOrderQuantity != null) {
                $product.find(SELECTORS.qtyInput).attr('max', item.quantityOptions.maxOrderQuantity);
            }

            refreshCardQtyState($product);
        });
    });
});